// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-alert[data-v-9b61d384]{border-radius:3px;padding:.75rem 1rem}.v-alert__icon[data-v-9b61d384]{display:flex;margin-right:.5rem}.v-alert--info[data-v-9b61d384]{background:#e0e3f0}.v-alert--danger[data-v-9b61d384]{background:rgba(248,17,53,.08);color:#f81135;padding:.75rem .625rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
